import * as Yup from 'yup';

export function newLocationSchema() {
  return Yup.object().shape({
    locationId: Yup.number().required('Required Field'),
    primary: Yup.boolean(),
    ...replaceLocationValidation,
  });
}

export const replaceLocationValidation = {
  replaceLocation: Yup.object().shape({
    id: Yup.number().when('$exist', {
      is: (exist) => exist,
      then: Yup.number().required(),
      otherwise: Yup.number(),
    }),
    effectiveAt: Yup.mixed().when({
      is: (exists) => exists !== undefined,
      then: Yup.mixed().notOneOf(['future', null, undefined], 'Please select an option'),
      otherwise: Yup.mixed(),
    }),
  }),
};
